import { Attachment } from "protogen/common_pb";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export default ({ attachments }: { attachments: Attachment[] }) => {
  return (
    <TableContainer component={Paper} sx={{ marginTop: "25px" }}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Filename</TableCell>
            <TableCell>Content Type</TableCell>
            <TableCell>Size</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {attachments.map((attachment, i) => (
            <TableRow
              key={i}
              hover
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: "pointer",
              }}
              onClick={() => {
                window.open(attachment.url, "Download");
              }}
            >
              <TableCell component="th" scope="row">
                {attachment.filename}
              </TableCell>
              <TableCell component="th" scope="row">
                {attachment.contentType}
              </TableCell>
              <TableCell component="th" scope="row">
                {attachment.fileSize}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
